export const ABSTRACT_IMAGES = [
    '/assets/img/auth-images/1410.jpg',
    '/assets/img/auth-images/2112.jpg',
    '/assets/img/auth-images/3302201.jpg',
    '/assets/img/auth-images/3336.jpg',
    '/assets/img/auth-images/3477.jpg',
    '/assets/img/auth-images/3551288.jpg',
    '/assets/img/auth-images/13312.jpg',
    '/assets/img/auth-images/13338.jpg',
    '/assets/img/auth-images/17450.jpg',
    '/assets/img/auth-images/17545.jpg',
    '/assets/img/auth-images/19007.jpg',
    '/assets/img/auth-images/2913.jpg',
    '/assets/img/auth-images/3072.jpg',
    '/assets/img/auth-images/3290338.jpg',
    '/assets/img/auth-images/3517927.jpg',
    '/assets/img/auth-images/3525865.jpg',
    '/assets/img/auth-images/3540662.jpg',
    '/assets/img/auth-images/3542463.jpg',
    '/assets/img/auth-images/5295725.jpg',
    '/assets/img/auth-images/5428.jpg',
    '/assets/img/auth-images/5437842.jpg',
    '/assets/img/auth-images/5594016.jpg',
    '/assets/img/auth-images/5650360.jpg',
    '/assets/img/auth-images/5878.jpg',
    '/assets/img/auth-images/7954.jpg',
    '/assets/img/auth-images/86.jpg',
    '/assets/img/auth-images/87398.jpg',
    '/assets/img/auth-images/OR68DX0.jpg',
    '/assets/img/auth-images/bg1.jpg',
    '/assets/img/auth-images/bg10.avif',
    '/assets/img/auth-images/bg11.avif',
    '/assets/img/auth-images/bg12.avif',
    '/assets/img/auth-images/bg13.avif',
    '/assets/img/auth-images/bg14.avif',
    '/assets/img/auth-images/bg15.jpg',
    '/assets/img/auth-images/bg16.jpg',
    '/assets/img/auth-images/bg17.jpg',
    '/assets/img/auth-images/bg18.jpg',
    '/assets/img/auth-images/bg19.jpg',
    '/assets/img/auth-images/bg2.jpg',
    '/assets/img/auth-images/bg20.jpg',
    '/assets/img/auth-images/bg21.jpg',
    '/assets/img/auth-images/bg22.jpg',
    '/assets/img/auth-images/bg23.jpg',
    '/assets/img/auth-images/bg3.jpg',
    '/assets/img/auth-images/bg4.avif',
    '/assets/img/auth-images/bg5.avif',
    '/assets/img/auth-images/bg6.avif',
    '/assets/img/auth-images/bg9.avif',
    '/assets/img/abstracts/aaron-burden-5UB407aLWJQ-unsplash.jpg',
    '/assets/img/abstracts/annie-spratt-jhw1cRdWkEI-unsplash.jpg',
    '/assets/img/abstracts/chris-barbalis-uZAuwQJJ-4s-unsplash.jpg',
    '/assets/img/abstracts/elizabeth-lies-ZWPerNlqUu0-unsplash.jpg',
    '/assets/img/abstracts/joanna-kosinska-Uvl3W4XWd4U-unsplash.jpg',
    '/assets/img/abstracts/kalle-kortelainen-3picpvVQiVM-unsplash.jpg',
    '/assets/img/abstracts/luca-bravo-xnqVGsbXgV4-unsplash.jpg',
    '/assets/img/abstracts/mike-newbry-7VyXToCotr4-unsplash.jpg',
    '/assets/img/abstracts/morgan-1TteudFnKoI-unsplash.jpg',
    '/assets/img/abstracts/nattu-adnan-Ai2TRdvI6gM-unsplash.jpg',
    '/assets/img/abstracts/pawel-czerwinski-h19obIsuogA-unsplash.jpg',
    '/assets/img/abstracts/pipe-a-HO-uMoDyjA8-unsplash.jpg',
    '/assets/img/abstracts/ryo-yoshitake-cusz0Bg-5mQ-unsplash.jpg',
    '/assets/img/abstracts/scott-webb-OxHPDs4WV8Y-unsplash.jpg',
    '/assets/img/abstracts/sharon-mccutcheon-dG9fUG0Jpos-unsplash.jpg',
    '/assets/img/abstracts/silvio-kundt-Fixg8KipOg8-unsplash.jpg',
    '/assets/img/abstracts/sumner-mahaffey-7Y0NshQLohk-unsplash.jpg',
    '/assets/img/abstracts/w-qjCHPZbeXCQ-unsplash.jpg',
];
